import React, { useContext, useEffect, useState } from 'react';
import Header from '../header';
import { PROJECTS } from '../../common/constants';
import { IPrice, IProject } from '../../interfaces';
import { getPricesControl } from '../../stores/control.stores';
import { toast } from 'react-toastify';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { MainContext } from '../../context/main.context';
import { useNavigate } from 'react-router-dom';


export default function Prices(): JSX.Element {
    const { language } = i18n;
    const navigate = useNavigate();
    const { project } = useContext(MainContext);
    const { t } = useTranslation();
    const [ projectValue, setProjectValue ] = useState<string>('');
    const [ pricesData, setPricesData ] = useState([]);

    useEffect((): void => {
        if (project) {
            if (PROJECTS.find((elem: IProject): boolean => elem.id === project)) {
                setProjectValue(project);
                return;
            }

            navigate('/prices');
        }
    }, []);

    useEffect((): void => {
        if (projectValue) {
            _getPricesControl();
        }
    }, [ projectValue ]);

    const _getPricesControl = (): void => {
        getPricesControl(projectValue).then(res => {
            const result = res?.data || [];

            setPricesData(result);
        }, err => {
            toast.error('GET_PRICES_CONTROL_ERROR');
            console.log('GET_PRICES_CONTROL_ERROR', { err });
        });
    }

    const _onChangeSelect = (event: React.FormEvent<HTMLSelectElement>): void => {
        const value: string = event.currentTarget.value;

        setProjectValue(value);

        navigate({
            pathname: '',
            search: `?project=${value}`,
        });
    }

    const _renderSelect = () => {
        return (
            <div className="prices-menu-project-select-box">
                <select
                    className="prices-menu-project-select"
                    value={projectValue}
                    onChange={(e) => _onChangeSelect(e)}
                >
                    <option value="">{t('prices.selectProject')}</option>
                    {
                        PROJECTS.map((project: IProject) => {
                            const { id, title } = project;

                            return (
                                <option value={id}>{title}</option>
                            );
                        })
                    }
                </select>
            </div>
        );
    }

    const _renderPriceList = () => {
        return (
            <div className="prices-list">
                {
                    pricesData.map((price: IPrice, index: number) => {
                        const {
                            id,
                            ruTitle,
                            ruValue,
                            enTitle,
                            enValue,
                            logoName,
                        } = price;

                        const srcPath: string = window.location.origin + `/prices/${id}/${logoName}`;
                        const isRuLng: boolean = language === 'ru';

                        const title: string = isRuLng ? ruTitle : enTitle;
                        const value: number = isRuLng ? ruValue : enValue;
                        const currency = isRuLng ? <span>&#8381;</span> : <span>&#36;</span>;

                        return (
                            <div key={`${id}_${index}`} className="prices-list-item">
                                <div className="prices-list-item-id">
                                    <img
                                        className="prices-list-item-logo"
                                        src={srcPath}
                                        alt={'logo'}
                                    />
                                </div>
                                <div className="prices-list-item-title text-overflow" title={title}>
                                    {title}
                                </div>
                                <div className="prices-list-item-value text-overflow">
                                    {value}
                                    {currency}
                                </div>
                            </div>
                        );
                    })
                }
                {
                    !pricesData.length && projectValue ?
                        <div className="prices-list-stub text-overflow">
                            {t('prices.noPrices')}
                        </div>
                    : null
                }
            </div>
        );
    }

    const _renderMenu = () => {
        return (
            <div className="prices-menu">
                {_renderSelect()}
                {_renderPriceList()}
            </div>

        );
    }

    return (
        <div className="prices">
            <Header origin="prices"/>
            {_renderMenu()}
        </div>
    );
}